import { diagnosticApi } from '../../../services/api';
import type { BlindSpotListFilter } from '../types';
import type {
  DiagnosticSummary,
  DiagnosticTrend,
  DiagnosticSchedule,
  DiagnosticExportFormat,
  RuntimeBlindSpotsSummary,
  RuntimeBlindSpot,
  DiagnosticReportResponse,
  QualificationStatus,
} from '../types';

export const diagnosticService = {
  async getQualificationStatus(): Promise<QualificationStatus> {
    return diagnosticApi.getQualificationStatus();
  },

  async getSummary(): Promise<DiagnosticSummary> {
    return diagnosticApi.getSummary();
  },

  async getRuntimeBlindSpotsSummary(): Promise<RuntimeBlindSpotsSummary> {
    return diagnosticApi.getRuntimeBlindSpotsSummary();
  },

  async getRuntimeBlindSpotsList(filter?: BlindSpotListFilter): Promise<RuntimeBlindSpot[]> {
    return diagnosticApi.getRuntimeBlindSpotsList(filter);
  },

  async recalculateBlindSpots(): Promise<RuntimeBlindSpotsSummary> {
    return diagnosticApi.recalculateBlindSpots();
  },

  async generateReport(): Promise<DiagnosticReportResponse> {
    return diagnosticApi.generateReport();
  },

  async getTrend(days = 30): Promise<DiagnosticTrend> {
    return diagnosticApi.getTrend(days);
  },

  async getSchedule(): Promise<DiagnosticSchedule> {
    return diagnosticApi.getSchedule();
  },

  async exportData(format: DiagnosticExportFormat): Promise<Blob> {
    return diagnosticApi.exportData(format);
  },
};
